import React, { ComponentPropsWithRef, useContext } from 'react'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import type { TypographyVariant } from '../types/mui'
import { MTypo } from '../components/MTypo/MTypo'
// import { ResponsiveYT } from '../components/ResponsiveYT'
interface Props extends ComponentPropsWithRef<'div'> {
    titleV: TypographyVariant
    bodyV: TypographyVariant
}

/**
 * Screen 5, 'Instructions'
 * After Screen 6 'Branding/Old start'
 * FIXME duplicated Branding.tsx
 * @param p
 * @returns
 */
export const HowTo = (p: Props) => {
    const { titleV, bodyV } = p
    const t = useTranslation(useCommonCtx())

    return (
        <div className="flex-1 flex flex-col justify-evenly items-center">
            <MTypo variant={titleV} className="text-center">
                {t('howto1_title')}
            </MTypo>
            <MTypo
                variant={bodyV}
                className="text-center italic"
                outerClassName="p-4"
            >
                {t('howto1_body')}
            </MTypo>
            {/* FIXME */}
            {/* <ResponsiveYT videoId="OS6pArgOfkY" /> */}
        </div>
    )
}
